import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import AppBar from '../AppBar';
var propTypes = {
  bodyClassname: PropTypes.string,
  id: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onRequestClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  expandedHeader: PropTypes.bool,
  bodyRef: PropTypes.func,
  appBarActions: PropTypes.func,
  useBackButtonOnMobile: PropTypes.bool
};
var defaultProps = {
  header: ''
};

var ModalFullscreen = function ModalFullscreen(_ref) {
  var bodyClassname = _ref.bodyClassname,
      id = _ref.id,
      header = _ref.header,
      expandedHeader = _ref.expandedHeader,
      children = _ref.children,
      onRequestClose = _ref.onRequestClose,
      bodyRef = _ref.bodyRef,
      appBarActions = _ref.appBarActions,
      useBackButtonOnMobile = _ref.useBackButtonOnMobile;
  var modalBodyClassname = cx({
    modal__body: true,
    'modal__body-skin': true
  }, bodyClassname);
  return /*#__PURE__*/React.createElement("div", {
    className: "modal--fullscreen"
  }, /*#__PURE__*/React.createElement(AppBar, {
    titleId: "__".concat(id, "__modal__header__"),
    title: !expandedHeader && /*#__PURE__*/React.createElement("h1", {
      id: "__".concat(id, "__modal__header__"),
      className: "appbar__title font-md fontweight-500"
    }, header),
    navIcon: useBackButtonOnMobile ? 'arrow_left' : 'close',
    navOnClick: onRequestClose,
    actionItems: appBarActions
  }), /*#__PURE__*/React.createElement("div", {
    id: "__".concat(id, "__modal__body__"),
    className: modalBodyClassname,
    ref: bodyRef
  }, expandedHeader && typeof header === 'string' && /*#__PURE__*/React.createElement("h1", {
    id: "__".concat(id, "__modal__header__"),
    className: "h1 margintop-0 marginbottom-lg"
  }, header), expandedHeader && typeof header !== 'string' && header, children));
};

ModalFullscreen.propTypes = propTypes;
ModalFullscreen.defaultProps = defaultProps;
ModalFullscreen.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ModalFullscreen",
  "props": {
    "header": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "bodyClassname": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onRequestClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }, {
          "name": "node"
        }]
      },
      "required": false,
      "description": ""
    },
    "expandedHeader": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "bodyRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "appBarActions": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "useBackButtonOnMobile": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
export default ModalFullscreen;